export default "__VITE_ASSET__5MAd810L__"